import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from '../utils/setRequestId';
import {checkNextStepForDuplicateFirstNameValue, isSecondStepNext, getUrlForStepSubmit} from '../utils/stepSubmit';

export const submitStep = ({step, data}) => {
  return (dispatch) => {
    const url = getUrlForStepSubmit(step);
    const {regType} = data;
    dispatch({
      type: A.GET_NEXT_STEP
    });
    setRequestId();

    return axios.post(url, data)
      .then((response) => {
        const {data} = response.data;
        const {
          nextStep,
          currentUserStepNumber,
          totalSteps,
          goBack,
          desktopCompletedStages,
          firstName,
          ...payload
        } = data;
        const formValues = checkNextStepForDuplicateFirstNameValue(nextStep, regType)
          ? {...payload, firstName}
          : payload;

        dispatch({
          type: A.GET_NEXT_STEP_SUCCESS,
          payload: {
            nextStep,
            currentUserStepNumber,
            totalSteps,
            goBack,
            desktopCompletedStages
          }
        });

        dispatch({
          type: A.SET_STEP_PAYLOAD,
          payload: formValues
        });
        dispatch({
          type: A.SET_USER_NAME,
          payload: isSecondStepNext(nextStep, regType) ? '' : firstName
        });
        dispatch({
          type: A.SET_SPECIFIC_STEP,
          payload: {step: null}
        });

        return nextStep;
      })
      .catch((err) => {
        return dispatch({
          type: A.GET_NEXT_STEP_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};

